import stellanPic from "@/public/images/artists/stellan.png";
import { Artist } from "@/types/types";

export const stellan = {
  id: "271",
  name: "Stellan",
  image: stellanPic,
  description: `Stellan's voice is soft and airy, with an effortless falsetto and a high range he handles with ease. The tone stays light and controlled even at the top.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fstellan-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Classical", "Falsetto", "Airy"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 55,
        high: 76,
      },
      sweetSpot: 65,
    },
  },
} as const satisfies Artist;
